import * as React from "react";
import { Trans } from "react-i18next";
import { PlayerFragmentFragment } from "../../../graphql/PlayerFragment.generated";

export const FriendshipCanceledActivity = ({
  actor,
  openProfile,
}: {
  actor: PlayerFragmentFragment | null;
  openProfile: () => void;
}) => {
  return (
    <>
      <Trans i18nKey="notification.friendship_canceled_activity">
        <button onClick={openProfile}>
          <strong>{{ actor: actor!.name }}</strong>
        </button>{" "}
        has unfriended you
      </Trans>
    </>
  );
};
